import React from 'react';
import { products, storeInfo } from '../data/mockData';
import { MessageCircle } from 'lucide-react';

const ProductCard = ({ product }) => (
  <div className="bg-[#111] border border-[#222] rounded-2xl overflow-hidden hover:border-[#c8ff00]/30 transition-all duration-300 group">
    <div className="overflow-hidden">
      <img
        src={product.image}
        alt={product.title}
        className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
      />
    </div>
    <div className="p-5">
      <h3 className="text-white font-bold text-lg mb-3">{product.title}</h3>
      <ul className="space-y-2">
        {product.items.map((item, i) => (
          <li key={i} className="flex items-center gap-2 text-gray-400 text-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-[#c8ff00] flex-shrink-0" />
            {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const ProductsSection = () => (
  <section id="products" className="py-20 bg-[#0f0f0f]">
    <div className="max-w-7xl mx-auto px-6">
      <h2 className="text-4xl md:text-5xl font-bold text-center mb-4">
        <span className="text-white">Products &amp; </span>
        <span className="text-[#c8ff00]">Accessories</span>
      </h2>
      <p className="text-gray-400 text-center mb-12 max-w-2xl mx-auto">
        Explore our wide range of quality products. From the latest vaping tech to traditional smoking essentials.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
        {products.map((product, index) => (
          <ProductCard key={index} product={product} />
        ))}
      </div>

      <div className="text-center">
        <p className="text-gray-500 text-sm mb-4">
          Product availability and brands may vary. Contact us or visit in-store for the latest stock.
        </p>
        <a
          href={storeInfo.contact.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#c8ff00] text-black font-semibold px-6 py-3 rounded-xl hover:bg-[#b8ef00] transition-colors duration-200"
        >
          <MessageCircle size={18} />
          Ask us on WhatsApp
        </a>
      </div>
    </div>
  </section>
);

export default ProductsSection;
